export default __webpack_public_path__ + "static/media/certificate.305b8686.svg";